import regeneratorRuntime from "/app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Input from '@/components/base/Input';
import ToolTip from '@/components/combined/ToolTip';
import { nets } from '@/constants';
import CombinedService from '@/api/combined';
import Linker from '../Linker';
import toasty from '../Toast';
import Logo from './Logo';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import { makeAddressInfo, makeBlockDetailLink, makeDAppAddress, makeHomeLink, makeShardDetailLink, makeTokenInfo, makeTxDetailLink } from '@/utils/link';
import clss from 'classnames'; // import { locales, languageNames } from '@/i18n/config'
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Header = function() {
    var router = useRouter();
    var ref3 = useState('light'), mode = ref3[0], setMode = ref3[1]; // theme
    var ref1 = useState(nets[0]), net = ref1[0], setNet = ref1[1];
    var ref2 = useState(false), loading = ref2[0], setLoading = ref2[1]; // const { locale } = useLanguage()
    useEffect(function() {
        var $html = document.querySelector('html');
        if ($html && mode) {
            $html.className = mode;
        }
    }, [
        mode
    ]); // const setLocale = useCallback((locale: string) => {
    //   Cookies.set('lang', locale)
    //   location && location.reload()
    // }, [])
    var handleEnter = useCallback(function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(value) {
            var combined, search, response, context, ref, Status, Result, Message, searchCondition, _ListData, block, item;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        value = value.trim().replace(/[^0-9a-zA-Z:@#]/g, '');
                        combined = new CombinedService(value);
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return combined.search();
                    case 6:
                        search = _ctx.sent;
                        setLoading(false);
                        response = search.response, context = search.context;
                        ref = response || {}, Status = ref.Status, Result = ref.Result, Message = ref.Message;
                        if (!(Status !== 0 && context.searchCondition !== 'Tx')) {
                            _ctx.next = 13;
                            break;
                        }
                        Message && toasty.error(Message);
                        return _ctx.abrupt("return", false);
                    case 13:
                        searchCondition = context.searchCondition;
                        _ctx.t0 = searchCondition;
                        _ctx.next = _ctx.t0 === 'Shard' ? 17 : _ctx.t0 === 'BlockHeight' ? 21 : _ctx.t0 === 'Block' ? 26 : _ctx.t0 === 'Tx' ? 28 : _ctx.t0 === 'Address' ? 33 : _ctx.t0 === 'Token' ? 37 : _ctx.t0 === 'DApp' ? 40 : 43;
                        break;
                    case 17:
                        if (!(!Result || !Result.length)) {
                            _ctx.next = 19;
                            break;
                        }
                        return _ctx.abrupt("return", toasty.error('Shard Not Found'));
                    case 19:
                        router.push(makeShardDetailLink(context.input));
                        return _ctx.abrupt("return");
                    case 21:
                        _ListData = _slicedToArray(Result.ListData, 1), block = _ListData[0];
                        if (!(typeof block === 'undefined')) {
                            _ctx.next = 24;
                            break;
                        }
                        return _ctx.abrupt("return", toasty.error('Not Found'));
                    case 24:
                        router.push(makeBlockDetailLink(block.Hash));
                        return _ctx.abrupt("return");
                    case 26:
                        router.push(makeBlockDetailLink(context.input));
                        return _ctx.abrupt("return");
                    case 28:
                        if (response) {
                            _ctx.next = 31;
                            break;
                        }
                        toasty.error('Not found');
                        return _ctx.abrupt("return");
                    case 31:
                        router.push(makeTxDetailLink(context.input));
                        return _ctx.abrupt("return");
                    case 33:
                        item = Result;
                        if (!item) {
                            _ctx.next = 37;
                            break;
                        }
                        router.push(makeAddressInfo(context.input));
                        return _ctx.abrupt("return");
                    case 37:
                        if (!Result) {
                            _ctx.next = 40;
                            break;
                        }
                        router.push(makeTokenInfo(context.input));
                        return _ctx.abrupt("return");
                    case 40:
                        if (!Result) {
                            _ctx.next = 43;
                            break;
                        }
                        router.push(makeDAppAddress(context.input));
                        return _ctx.abrupt("return");
                    case 43:
                        toasty({
                            type: 'error',
                            content: 'Invalid Input'
                        });
                        _ctx.next = 50;
                        break;
                    case 46:
                        _ctx.prev = 46;
                        _ctx.t1 = _ctx["catch"](3);
                        setLoading(false);
                        toasty({
                            type: 'error',
                            content: _ctx.t1.Message || _ctx.t1
                        });
                    case 50:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    46
                ]
            ]);
        }));
        return function(value) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return(/*#__PURE__*/ _jsx("header", {
        className: "bg-box container-min-w",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "mx-auto h-[62px] flex items-center justify-between container-w",
            children: [
                /*#__PURE__*/ _jsx(Linker, {
                    href: makeHomeLink(),
                    children: /*#__PURE__*/ _jsx(Logo, {})
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex-1 flex justify-center",
                    children: /*#__PURE__*/ _jsx(Input, {
                        mode: "search",
                        placeholder: "@shard, height@shard, height, hash, or address",
                        className: "w-[600px] rounded-[36px] h-[42px] text-[14px] pr-[20px] focus:border-primary text-base",
                        loading: loading,
                        onEnter: handleEnter
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "ml-[28px]"
                }),
                /*#__PURE__*/ _jsx(ToolTip, {
                    options: nets.map(function(n) {
                        /*#__PURE__*/ return _jsx("div", {
                            className: "".concat(clss({
                                active: n === net
                            }), " item"),
                            onClick: function() {
                                return setNet(n);
                            },
                            children: n
                        }, n);
                    }),
                    target: /*#__PURE__*/ _jsxs("div", {
                        className: "flex h-[42px] rounded-[21px] border-base items-center border-[1px] cursor-pointer pl-[17px] text-desc text-[14px] pr-[25px]",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "inline-block w-[7px] h-[7px] mr-[7px] bg-[#6DDF7F] rounded-full"
                            }),
                            net
                        ]
                    })
                })
            ]
        })
    }));
};
export default Header;
